import { createSlice } from "@reduxjs/toolkit";
export const formUpdateSlice = createSlice({
  name: "formUpdate",
  initialState: {
    displayForm: false,
    displayRemove: false,
    type: "",
    deleteApiPath: "",
    imageUpload: false,
    formData: {},
    displayLargeImage: false,
    displayCancel: false,
  },
  reducers: {
    updateFormInfo: (state, data) => {
      state.formData = data.payload.formData;
      state.displayForm = data.payload.displayForm;
      state.imageUpload = data.payload.imageUpload;
    },

    displayForm: (state, data) => {
      state.displayForm = data.payload.displayForm;
    },
    displayRemoveAlert: (state, data) => {
      state.formData = data.payload.formData;
      state.displayRemove = data.payload.displayRemove;
      state.type = data.payload.type;
      state.deleteApiPath = data.payload.deleteApiPath;
    },

    displayLargeImage: (state, data) => {
      state.displayLargeImage = data.payload.displayLargeImage;
      state.formData = data.payload.formData;
    },

    displayCancelAlert: (state, data) => {
      state.formData = data.payload.formData;
      state.displayCancel = data.payload.displayCancel;
    },
  },
});

export const {
  updateFormInfo,
  displayForm,
  displayRemoveAlert,
  displayLargeImage,
  displayCancelAlert,
} = formUpdateSlice.actions;

export const formUpdateData = (state) =>
  state.rootReducer.formUpdateReducer.formData;

export const formUpdateStatus = (state) =>
  state.rootReducer.formUpdateReducer.displayForm;

export const imageUploadStatus = (state) =>
  state.rootReducer.formUpdateReducer.imageUpload;

export const deleteStatus = (state) =>
  state.rootReducer.formUpdateReducer.displayRemove;

export const largeImageStatus = (state) =>
  state.rootReducer.formUpdateReducer.displayLargeImage;

export const displayCancelStatus = (state) =>
  state.rootReducer.formUpdateReducer.displayCancel;

export const itemType = (state) => state.rootReducer.formUpdateReducer.type;

export const deletePath = (state) =>
  state.rootReducer.formUpdateReducer.deleteApiPath;

export default formUpdateSlice.reducer;
